module.exports = __webpack_public_path__ + "static/img/4.229431a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/sp/4.png
// module id = g4dw
// module chunks = 0